import { render, staticRenderFns } from "./MaxxFormFieldsDisplay.vue?vue&type=template&id=72606bdc&scoped=true&"
import script from "./MaxxFormFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./MaxxFormFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MaxxFormFieldsDisplay.vue?vue&type=style&index=0&id=72606bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72606bdc",
  null
  
)

export default component.exports